// Currency configuration
const roundUpTo10 = (amount) => Math.ceil(amount / 10) * 10;

const convertOrNull = (usdAmount, fn) => {
  if (usdAmount == null) return null;
  return fn(usdAmount);
};

export const CURRENCIES = {
  usd: {
    conversion: (usdAmount) => usdAmount,
    symbol: '$',
  },
  eur: {
    conversion: (usdAmount) => convertOrNull(usdAmount, (x) => roundUpTo10(x * 0.85 + 200)),
    symbol: '€',
  },
  gbp: {
    conversion: (usdAmount) => convertOrNull(usdAmount, (x) => roundUpTo10(x * 0.75 + 200)),
    symbol: '£',
  },
};

// Base pricing data
export const BASE_PRICING = {
  complianceReporting: [
    { value: 1, label: '1', usd: 5500 },
    { value: 2, label: '2', usd: 4500 },
    { value: 3, label: '3', usd: 3670 },
    { value: 4, label: '4', usd: 3000 },
    { value: 5, label: '5+', usd: 2500 },
  ],
  globalPayEquityModeling: [
    { value: 1, label: '<500', longLabel: 'Under 500', usd: 8020 },
    { value: 2, label: '500-999', longLabel: '500-999', usd: 13600 },
    { value: 3, label: '1K-5K', longLabel: '1,000-5,000', usd: 21890 },
    { value: 4, label: '5K+', longLabel: '5,000+', usd: null },
  ],
};

// Layout constants
export const LAYOUT_CONSTANTS = {
  CARD_MIN_HEIGHT: { xs: 320, md: 360 },
  PRICE_BLOCK_MIN_HEIGHT: 120,
  TABLE_HEADER_MIN_HEIGHT: 160,
};

// Slider styles
export const SLIDER_SX = {
  width: '75%',
  mx: 'auto',
  '& .MuiSlider-mark': { display: 'none' },
  '& .MuiSlider-rail': { height: 8 },
  '& .MuiSlider-track': {
    height: 8,
    border: 'none',
    backgroundColor: '#4f45e4',
  },
  '& .MuiSlider-thumb': {
    width: 20,
    height: 20,
    border: 'none',
    '&:hover, &:focus, &:active': {
      width: 20,
      height: 20,
      border: 'none',
      boxShadow: '0px 0px 0px 8px rgba(79, 69, 228, 0.16)',
    },
  },
  alignSelf: 'center',
};

// Features list
export const FEATURES = [
  'From data to results in 1 week',
  '10x cheaper than legacy vendors like Syndio and Sysarb',
  'No multi-year contracts or lock-in',
];
